module.exports = __webpack_public_path__ + "img/DAVID_CANNON_27-rs.1ebfa2be.jpg";